// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1gYjv","colMaxWidth":"Table_colMaxWidth__2ovE7"};